import axios from 'axios';
import API_URL from "./apiPath";

let handlerEnabled = false;

const requestHandler = (request) => {
    if (handlerEnabled) {
        console.log('Request: ' + request.url + ' ' + JSON.stringify(request.data));
    }

    // ? No bearer token � cookie handles auth
    return request;
};

const errorHandler = (error) => {
    if (handlerEnabled && error.response) {
        console.log('Error: ' + error.response.status + ' ' + error.config.url);
    }

    const isLoginRequest =
        error.config &&
        error.config.url &&
        error.config.url.toLowerCase().includes('/webcmtoken');

    if (error.response && error.response.status === 401 && !isLoginRequest) {
        console.log("401 received", error.config.url);

        // optional redirect behavior
        // sessionStorage.clear();
        // window.location.href = "/";
    }

    return Promise.reject({ ...error });
};

const successHandler = (response) => {
    if (handlerEnabled) {
        console.log('Success: ' + response.config.url);
    }

    return response;
};

const axiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-App-Name': 'webcm'
    }
});

axiosInstance.interceptors.request.use(
    request => requestHandler(request),
    error => errorHandler(error)
);

axiosInstance.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
);

export default axiosInstance;